import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiAction } from "../../store/ui-gemini";

const WelcomeModal = () => {
  const dispatch = useDispatch();
  const open = useSelector((s) => s.ui.isWelcomeModalOpen);
  const [isClosing, setIsClosing] = useState(false);
  const closeTimerRef = useRef(null);

  // If modal re-opens while a close animation is pending, cancel close and reset state
  useEffect(() => {
    if (open) {
      setIsClosing(false);
      if (closeTimerRef.current) {
        clearTimeout(closeTimerRef.current);
        closeTimerRef.current = null;
      }
    }
  }, [open]);

  if (!open) return null;

  const close = (e) => {
    e?.stopPropagation?.();
    setIsClosing(true);
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
    }
    closeTimerRef.current = setTimeout(() => {
      dispatch(uiAction.closeWelcomeModal());
      closeTimerRef.current = null;
    }, 200);
  };

  const gotoLogin = () => {
    window.location.href = "/login";
  };

  const gotoSignup = () => {
    window.location.href = "/signup";
  };

  const stayLoggedOut = () => {
    close();
  };

  return (
    <div 
      onClick={close} 
      className={`fixed inset-0 z-[70] flex items-center justify-center bg-black/50 transition-opacity duration-200 ${
        isClosing ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div 
        onClick={(e) => e.stopPropagation()} 
        className={`bg-white rounded-xl shadow-2xl w-[90vw] max-w-sm mx-4 transform transition-all duration-200 ${
          isClosing ? 'scale-95 opacity-0' : 'scale-100 opacity-100'
        }`}
      >
        {/* Header */}
        <div className="px-6 pt-6 pb-4">
          <h2 className="text-xl font-semibold text-gray-900 text-center">
            Thanks for trying Gospel Truth AI
          </h2>
        </div>

        {/* Content */}
        <div className="px-6 pb-6">
          <p className="text-sm text-gray-600 text-center leading-relaxed mb-6">
            Log in or sign up to get smarter, deeper responses.
          </p>

          {/* Buttons */}
          <div className="space-y-3">
            {/* Login Button */}
            <button 
              onClick={gotoLogin}
              className="w-full bg-[#14A6EA] text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200 active:scale-[0.98]"
            >
              Log in
            </button>

            {/* Sign up Button */}
            <button 
              onClick={gotoSignup}
              className="w-full bg-white border border-gray-300 hover:bg-gray-50 text-gray-900 font-medium py-2 px-4 rounded-lg transition-colors duration-200 active:scale-[0.98]"
            >
              Sign up for free
            </button>

            {/* Stay logged out link */}
            <div className="text-center pt-2">
              <button 
                onClick={stayLoggedOut}
                className="text-sm text-gray-500 hover:text-gray-700 underline transition-colors duration-200"
              >
                Stay logged out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
